// Tipos de gráficos que são passados na URL da requisição no endpoint
// de configuração de cores, fontes e esquema de cores.
export const configurationServiceChartTypes = {
  simpleChart: 'simpleChart',
  multipleCrossChart: 'multipleCrossChart',
  evolutiveChart: 'evolutiveChart',
  evolutiveCrossChart: 'evolutiveCrossChart',
  simpleCrossChart: 'simpleCrossChart',
  correlationAutoChart: 'correlationAutoChart',
  correlationManualChart: 'correlationManualChart',
}